import React, { FC } from "react";

import { ModalWrapper, ModalProps } from "../Modal";
import { SimpleAction } from "../../../types/GlobalTypes";
import { Button } from "../Button";

type Props = {
  cancel: SimpleAction;
  proceed: SimpleAction;
  dataTest?: string;
} & Omit<ModalProps, "close">;

export const DecisionDialog: FC<Props> = ({
  cancel,
  proceed,
  children,
  dataTest,
  ...rest
}) => {
  return (
    <ModalWrapper close={cancel.onClick} {...rest}>
      <div
        className="flex flex-col justify-between text-gray-300"
        data-test={`${dataTest}-content`}
      >
        <div className="pb-8">{children}</div>

        <div className="flex justify-between gap-8">
          <Button
            className="px-5 grow"
            onClick={cancel.onClick}
            dataTest={`${dataTest}-cancel-button`}
          >
            {cancel.label}
          </Button>

          <Button
            className="px-5 grow"
            variant={Button.variant.PRIMARY}
            onClick={proceed.onClick}
            dataTest={`${dataTest}-proceed-button`}
          >
            {proceed.label}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};
